import { observable } from 'mobx';

import { ITranslationsCollection } from '@estee/elc-service';

export class TranslationRepository {
    @observable public translations: ITranslationsCollection = {};

    public loadTranslations = (translations: ITranslationsCollection) => {
        this.translations = translations;
    };
}
